module.exports = __webpack_public_path__ + "img/enuk.ce5a2bd9.png";